import React, { useState } from 'react';
import { useI18nContext } from '@ecg-marktplaats/js-react-i18n';
import { VerticalListing, Link, MaskedLink } from '@hz-design-system/web-ui';
import { formatImageUrl, ImageSize } from '@ecg-marktplaats/media-util-js-lib';

import formatPrice from './utils/formatPrice';
import { TFeedItem } from 'types/TFeeds';

type TFeedItemProps = {
  item: TFeedItem;
  onClick: Function;
  shouldOpenInNewTab?: boolean;
};

const FeedItem = ({ item, onClick, shouldOpenInNewTab }: TFeedItemProps) => {
  const { t } = useI18nContext();
  const [url, setUrl] = useState(item.url);
  const LinkComponent = item.thinContent ? MaskedLink : Link;

  return (
    <LinkComponent
      kind="block"
      href={url}
      onClick={() => onClick(item.correlationId)}
      onContextMenu={() => {
        const newUrl = `${item.url}${item.url.includes('?') ? '&' : '?'}correlationId=${item.correlationId}`;
        setUrl(newUrl);
      }}
      {...(shouldOpenInNewTab && { target: '_blank' })}
    >
      <VerticalListing
        title={item.title}
        price={formatPrice(item.price, t, true, item.isPricePerMonth)}
        imageSrc={formatImageUrl(item.picture?.url, ImageSize.Large, item.picture?.sizes)}
        imageLoading="lazy"
        decoding="async"
        imageOverlayLabel={item.isHomepageAdLabel ? t('l1.feeds.item.traits.homepage_ad') : ''}
      />
    </LinkComponent>
  );
};

export default React.memo(FeedItem);
